import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02996ed4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"border-bottom":"1px solid #eee"} }
const _hoisted_2 = { class: "borrow-applyDetail" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "step1" }, "申请事项三", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"20px"} }, "印章、证照刻制申请", -1))
const _hoisted_5 = { style: {"color":"#333"} }

import {
  ref,
  onMounted,
  withDefaults,
  watch,
} from "vue";
import HeadTitle from "@/components/HeadTitle.vue";
import RisTable from "@/components/Table.vue";
import { getBusinessApplyThirdInfo } from "@/api/process_bussiness";
import { PLAINOPTIONS } from "@/const/home";


export default /*#__PURE__*/_defineComponent({
  props: {
    folwId: { default: 0 },
    update: { type: Boolean, default: false }
  },
  emits: ["change-status"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { folwId: number, update: boolean }




const GsDocumentCollection = ref<string>("");
watch(
  () => props.update,
  (val, oldval) => {
    if (val != oldval) {
      getdata();
    }
  }
);
const getdata = async () => {
  const { Data } = await getBusinessApplyThirdInfo({
    BranchCompanyFlowId: props.folwId,
  });
  GsDocumentCollection.value = Data?.PageData.GsDocumentCollection || "";

  $emit("change-status", {
    buttons: Data?.ActionButtons,
    flowId: Data?.WorkFlowId,
    ApplicationInfo:Data?.ApplicationInfo,
    ApplicationTime:Data?.ApplicationTime
  });
};
onMounted(async () => {
  getdata();
});

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeadTitle, {
      title: "工商设立申请",
      style: {"margin-top":"24px"}
    }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_a_checkbox_group, {
        disabled: "",
        value: GsDocumentCollection.value.split(',')
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(GsDocumentCollection.value.split(','), (item, index) => {
            return (_openBlock(), _createBlock(_component_a_checkbox, {
              key: index,
              class: _normalizeClass(index == 9 ? 'nomargin' : ''),
              value: item.toString(),
              label: item
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(PLAINOPTIONS)[item - 1]), 1)
              ]),
              _: 2
            }, 1032, ["class", "value", "label"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["value"])
    ])
  ]))
}
}

})